import { createAsyncThunk } from "@reduxjs/toolkit";
import localhost, { downloadFileFromResponse } from "apis/localhost";
import mapActivityLogEntry from "slices/activityLog/mapActivityLogEntry";

const BASE_URL = "/api/activity/summary";
const ACTIVITY_URL = "/api/activity/summary/log";
const BY_AREA_FILE_NAME = "usage-stats-by-area.csv";
const BY_USER_FILE_NAME = "usage-stats-by-user.csv";
const LOG_FILE_NAME = "usage-stats-log.csv";
const CSV_MIME_TYPE = "text/csv";

export const ACTIVITY_PAGE_SIZE = 50;

const buildParams = ({ range, from, to, source, sort, q } = {}) => {
  const params = {};
  if (range) {
    params.range = range;
  }
  if (from) {
    params.from = from;
  }
  if (to) {
    params.to = to;
  }
  if (source) {
    params.source = source;
  }
  if (sort) {
    params.sort = sort;
  }
  if (q) {
    params.q = q;
  }
  return params;
};

export const fetchByArea = createAsyncThunk(
  "usageStats/fetchByArea",
  async (_, { getState }) => {
    const { filters } = getState().usageStats;
    const { data } = await localhost.get(`${BASE_URL}/by-area`, {
      params: buildParams(filters),
    });
    return data;
  }
);

export const fetchByUser = createAsyncThunk(
  "usageStats/fetchByUser",
  async ({ sort = "total" } = {}, { getState }) => {
    const { filters } = getState().usageStats;
    const { data } = await localhost.get(`${BASE_URL}/by-user`, {
      params: buildParams({ ...filters, sort }),
    });
    return data;
  }
);

export const fetchActivityFeed = createAsyncThunk(
  "usageStats/fetchActivityFeed",
  async ({ offset = 0, pageSize = ACTIVITY_PAGE_SIZE } = {}, { getState }) => {
    const { activitySearch, activitySort } = getState().usageStats;
    const { data } = await localhost.get(ACTIVITY_URL, {
      params: {
        offset,
        pageSize,
        sort: activitySort.field,
        order: activitySort.direction,
        ...(activitySearch ? { q: activitySearch } : {}),
      },
    });
    return {
      offset,
      rows: data.rows.map(mapActivityLogEntry),
      total: data.total,
      filteredTotal: data.filteredTotal,
    };
  }
);

export const exportByAreaThunk = createAsyncThunk(
  "usageStats/exportByArea",
  async (_, { getState }) => {
    const { filters } = getState().usageStats;
    const response = await localhost.get(`${BASE_URL}/by-area/export`, {
      params: buildParams(filters),
      responseType: "blob",
    });
    downloadFileFromResponse(response.data, BY_AREA_FILE_NAME, {
      type: CSV_MIME_TYPE,
    });
  }
);

export const exportByUserThunk = createAsyncThunk(
  "usageStats/exportByUser",
  async (_, { getState }) => {
    const { filters } = getState().usageStats;
    const response = await localhost.get(`${BASE_URL}/by-user/export`, {
      params: buildParams(filters),
      responseType: "blob",
    });
    downloadFileFromResponse(response.data, BY_USER_FILE_NAME, {
      type: CSV_MIME_TYPE,
    });
  }
);

export const exportLogThunk = createAsyncThunk(
  "usageStats/exportLog",
  async (_, { getState }) => {
    const { activitySearch, activitySort } = getState().usageStats;
    const response = await localhost.get(`${ACTIVITY_URL}/export`, {
      params: {
        sort: activitySort.field,
        order: activitySort.direction,
        ...(activitySearch ? { q: activitySearch } : {}),
      },
      responseType: "blob",
    });
    downloadFileFromResponse(response.data, LOG_FILE_NAME, {
      type: CSV_MIME_TYPE,
    });
  }
);
